export const germany = {
  slug: "germany",
  name: "Germany",
  flag: "🇩🇪",
  tagline: "Engineering Excellence Meets Free Education",
  heroImg: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?q=80&w=1600&auto=format&fit=crop",
  accentColor: "#1A3A5C",
  students: "60+",
  avgTuition: "€0–€3,000/yr",
  avgLiving: "€700–€1,000/mo",
  workPermit: "18 months post-study",
  ieltsReq: "6.0–7.0",
  intakeMonths: ["October (WS)", "April (SS)"],
  overview:
    "Germany is the world's #1 destination for tuition-free public university education. With globally ranked institutions like TU Munich and Heidelberg, it's the go-to for engineering, sciences, and business — with growing English-taught master's programmes.",
  whyChoose: [
    { icon: "🎓", title: "Mostly Free Tuition", desc: "Public universities charge only a semester fee (€150–€350). Save lakhs compared to US/UK." },
    { icon: "🏭", title: "Industrial Powerhouse", desc: "Home to BMW, Siemens, SAP & 2,300+ hidden champion companies actively hiring international talent." },
    { icon: "🌐", title: "English Programmes", desc: "1,500+ fully English-taught master's programmes — no German required to get started." },
    { icon: "📋", title: "18-Month Job Seeker Visa", desc: "After graduation, stay 18 months to find work — one of Europe's most generous post-study permits." },
    { icon: "🏥", title: "Quality of Life", desc: "Excellent public transport, healthcare, and safety — consistently ranked top 10 globally for students." },
    { icon: "🤝", title: "PR Pathway", desc: "21 months to permanent residency after employment — one of the fastest EU routes." },
  ],
  process: [
    { step: "01", title: "APS Certificate", desc: "Indian students need APS (Academic Evaluation Centre) verification — we handle all documentation." },
    { step: "02", title: "University Applications", desc: "Apply via uni-assist portal or directly. We craft German-standard motivation letters and CVs." },
    { step: "03", title: "Blocked Account & Visa", desc: "Open a blocked account (€11,208 required), then apply for student visa at German consulate." },
    { step: "04", title: "Enrolment & Arrival", desc: "Register at Einwohnermeldeamt, enrol at university, open a local bank account — we prep you fully." },
  ],
  universities: [
    "tu-munich", "lmu-munich", "heidelberg", "rwth-aachen", "kit-karlsruhe",
    "humboldt-berlin", "fu-berlin", "tu-berlin", "tu-dresden", "uni-hamburg",
    "uni-cologne", "uni-frankfurt", "uni-stuttgart", "uni-bonn", "uni-freiburg",
    "uni-tubingen", "uni-erlangen", "uni-wurzburg", "tu-darmstadt", "uni-munster",
    "uni-bochum", "tu-braunschweig", "uni-jena", "uni-mainz", "uni-kiel",
  ],
  stats: [
    { n: "60+",  label: "Students Placed" },
    { n: "€0",   label: "Min. Tuition/yr" },
    { n: "95%",  label: "Visa Success" },
    { n: "18mo", label: "Post-Study Permit" },
  ],
};
